// extracted by css-extract-rspack-plugin
export default {"jsonEditor":"jsonEditor-kTshi4"};